// extracted by mini-css-extract-plugin
export default {"root":"styles-module__root--DKxuw","buttonContainer":"styles-module__buttonContainer--ePLvo"};